import { Component, OnInit, OnDestroy } from '@angular/core';
import { EventEmitterService } from '../event-emitter.service';
import { ActivatedRoute, Router} from '@angular/router';
import { TotemService } from '../totem.service';
// 1

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  // 2
  public actual: string = '';

  estadoHeader = true;
  estadofooter = true;
  menuOpen = false;
  constructor(private eventEmitterService: EventEmitterService, private router: Router,
              public totemService: TotemService) {
    router.events.subscribe((val) => {
    });
    // 3
    this.actual = this.totemService.actualLanguage;
   }

  ngOnInit() {
      this.eventEmitterService.subsVar = this.eventEmitterService.
      invokeHeaderComponentFunction.subscribe((name: string) => {
        console.log('llamado header header');
        if (name === 'show') {
          this.mostrarHeader();
        } else if (name === 'hide') {
          this.ocultarHeader();
        }
      });
  }

  ngOnDestroy() {
    this.eventEmitterService.subsVar.unsubscribe();
  }

  ocultarHeader() {
    this.estadoHeader = false;
    this.estadofooter = false;
  }
  mostrarHeader() {
    this.estadoHeader = true;
    this.estadofooter = true;
  }

// 4
  changeLanguage(language: any) {
    this.actual = language;
    this.totemService.changeLanguage(language);
  }
  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }
}
